var _rect, _text, _rect2, _circle, _text2, _rect3, _circle2, _text3, _rect4, _circle3, _text4, _rect5, _circle4, _text5, _path, _circle5, _path2, _text6, _path3, _text7, _rect6, _circle6, _circle7, _text8, _path4, _circle8, _circle9, _rect7, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentProcessTransformationBeforeAfterDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 450,
    viewBox: "0 0 720 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Process transformation before and after") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 448,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 42,
    fill: "#FF2775",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "BEFORE \u2014 FRAGMENTED ACTIVITY"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 69,
    width: 130,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#087CFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 93,
    r: 5,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 98,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "INBOX")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 69,
    width: 130,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#30D6A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 93,
    r: 5,
    fill: "#30D6A1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 98,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "SPREADSHEET")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 130,
    width: 130,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#FF2775"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 154,
    r: 5,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 159,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "CHAT THREAD")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 130,
    width: 130,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#F4B63D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 154,
    r: 5,
    fill: "#F4B63D"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 159,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "LEGACY TOOL")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 93h12M164 154h12",
    stroke: "#8DA8C2",
    strokeWidth: 2,
    strokeDasharray: "3 5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 234,
    r: 38,
    fill: "#07152A",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m156 220 28 28m0-28-28 28",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 298,
    fill: "#536985",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 170,
    dy: 0
  }, "DELAY"), /*#__PURE__*/React.createElement("tspan", {
    x: 170,
    dy: 15
  }, "DUPLICATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 170,
    dy: 15
  }, "BLIND SPOTS"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326 224h56m-8-6 8 6-8 6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 404,
    y: 42,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 404,
    dy: 0
  }, "AFTER \u2014 ONE MANAGED FLOW"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 69,
    width: 286,
    height: 235,
    rx: 22,
    fill: "#07152A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 171,
    r: 67,
    fill: "#0B2340",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 171,
    r: 52,
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.35,
    strokeDasharray: "5 7"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 541,
    y: 158,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 541,
    dy: 0
  }, "ONE MANAGED"), /*#__PURE__*/React.createElement("tspan", {
    x: 541,
    dy: 21
  }, "WORKFLOW"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429 171h45M608 171h45",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 171,
    r: 7,
    fill: "#30D6A1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 171,
    r: 7,
    fill: "#F4B63D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 329,
    width: 286,
    height: 78,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 356,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 420,
    dy: 0
  }, "CLEAR OWNERSHIP \xB7 LIVE STATUS"), /*#__PURE__*/React.createElement("tspan", {
    x: 420,
    dy: 17
  }, "EVIDENCE AT EVERY DECISION"), /*#__PURE__*/React.createElement("tspan", {
    x: 420,
    dy: 17
  }, "ACTION WITHOUT MANUAL CHASING"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentProcessTransformationBeforeAfterDesktop);
export default __webpack_public_path__ + "static/media/custom-development-process-transformation-before-after-desktop.9ec3c8b2c3d5ee25a2a323094268f5a8.svg";
export { ForwardRef as ReactComponent };